<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'samplemanage-sampleStockChangeLog',
  components: {
    PageTable,
  },
}
</script>
